import React from 'react';
import { AboutSection } from './components/AboutSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { Navigation } from './components/Navigation';
import { ProcessSection } from './components/ProcessSection';
import { QuoteForm } from './components/QuoteForm';
import { ServicesSection } from './components/ServicesSection';
import { useLanguage } from './contexts/LanguageContext';
import { useSeo } from './hooks/useSeo';
import { buildStructuredData } from './utils/structuredData';
export function App() {
  const {
    language,
    t
  } = useLanguage();
  useSeo({
    title: t.seo.title,
    description: t.seo.description,
    structuredData: buildStructuredData(language)
  });
  return <div className="min-h-screen w-full overflow-x-hidden bg-ivory" data-id="element-0" data-mp="28tw9l3rof699">
      <Navigation data-id="element-1" data-mp="28s31dk1f0dz5" />

      <main data-id="element-2" data-mp="23vuokdaowwv5">
        <Hero data-id="element-3" data-mp="23w4ey1znd61d" />
        <ServicesSection data-id="element-4" data-mp="23ujjma5idj2g" />
        <ProcessSection data-id="element-5" data-mp="23t8hsfvmildz" />
        <QuoteForm data-id="element-6" data-mp="3ijxsgzk2wgo4" />
        <AboutSection data-id="element-7" data-mp="3ikr002qv3a7b" />
        <FinalCta data-id="element-8" data-mp="3ij668fcdfvai" />
      </main>

      <Footer data-id="element-9" data-mp="3ihuyy5jpw5en" />
    </div>;
}